<div [id]="'Field:' + model.Id + ':PreviousValue'">
    Previous: {{ getPreviousValue() }}
    <aurora-icon-button
        [attr.id]="'Field:' + model.Id + ':RevertToPreviousValue'"
        class="ms-1"
        icon="undo"
        variant="ghost"
        label="Revert to previous value"
        [tooltip]="false"
        (click)="revertToPreviousValue.emit()">
    </aurora-icon-button>
</div>